import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getprofile, updateProfile } from "../../slices/user";
import MemberFamily from "./MemberFamily";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
import { clearMessage } from '../../slices/messages';

const Profile = () => {
    const { user, Status } = useSelector((state) => state.auth);
    const { message } = useSelector((state) => state.message);

    const { t } = useTranslation();

    const firstitem = {
        type: "",
        name: "",
        dob: "",
    };

    const [items, setItems] = useState([firstitem]);
    const [form, setForm] = useState({});
    const [submitted, setSubmitted] = useState(0);
    const [successMsg, setSuccessMsg] = useState(false);
    const [profileApprove, setProfileApprove] = useState('');

    const current_date = new Date().getFullYear();
    const dispatch = useDispatch();

    // dispatch(getprofile());
    useEffect(() => {
        dispatch(getprofile());
        if (Status == "Pending") {
            setSubmitted(1);
        } else {
            setSubmitted(0);
        }
    }, [dispatch]);

    useEffect(() => {
        setForm(user);
        setProfileApprove(user.approve);
        if (user.member_details && user.member_details.length > 0) {
            setItems(user.member_details);
        }
        if (Status == "Pending") {
            setSubmitted(1);
        } else {
            setSubmitted(0);
        }
    }, [user]);


    const handleChange = (e) => {
        if (e.target.name == "avatar") {
            setForm({ ...form, [e.target.name]: e.target.files[0] });
        } else {
            setForm({ ...form, [e.target.name]: e.target.value });
        }
    }

    const addRows = (e) => {
        const item = {
            type: "",
            name: "",
            dob: "",
        };
        setItems([...items, item]);
    }

    const removeRows = (idx) => {
        const tempItems = [...items]; // to avoid  direct state mutation
        tempItems.splice(idx, 1);
        setItems(tempItems);
    }

    const updateState = (e) => {
        let index = e.target.attributes.index.value; // index of state array -rows
        let fieldValue = e.target.value; // value
        let fieldnName = e.target.name; // value

        const tempRows = [...items]; // avoid direct state mutation
        const tempObj = items[index]; // copy state object at index to a temporary object
        tempObj[fieldnName] = fieldValue; // modify temporary object

        // return object to rows` clone
        tempRows[index] = tempObj;
        setItems(tempRows); // update state

    };

    const handleSubmit = (e) => {
        e.preventDefault();
        var inputs = form;
        const newObj = Object.assign({ items: items }, inputs);
        setSubmitted(1);
        dispatch(updateProfile(newObj))
            .unwrap()
            .then(() => {
                setSuccessMsg(true);
                dispatch(getprofile());
                window.scrollTo(0, 0);
            })
            .catch((e) => {
                setSuccessMsg(false);
                window.scrollTo(0, 0);
                setSubmitted(0);
            });
    }
    return (
        <div className="container">
            <section className="mt-5 pt-5 gallery">
                <div className="card bg-2 login-card bg-primary-new register-card p-6">
                    <div className="card-body">
                        <div className='section-title text-center' id="heading_title">
                            <h1 className="mb-0"><span className='font-color-1'>{t('profile')}</span></h1>
                        </div>
                        {(message && Status == "Failed") && (
                            <div className="col-md-12 error-section mt-2-5">
                                <div
                                    className="alert alert-warning"
                                    role="alert"
                                >
                                    {message}
                                </div>
                            </div>
                        )}

                        {
                            profileApprove == "N" &&
                                <div className="col-md-12 error-section mt-3">
                                    <div className="alert alert-warning" role="alert" > {t('profile_not_approve')} </div>
                                </div>
                        }

                        {successMsg &&
                            <div className="col-md-12 error-section">
                                <div className="alert alert-success" role="alert" > {t('profile_update')}</div>
                            </div>
                        }
                        <form action="#" onSubmit={e => handleSubmit(e)} method="post" autoComplete="off">
                            <div className="row mt-2-5">
                                <div className="col-md-6 form-group mb-1-5">
                                    <label>{t('village')}</label>
                                    <input type="text" className="form-control" placeholder={t('enter_village')} name="village" onChange={(e) => handleChange(e)} value={form?.village ? form?.village : ""} />
                                </div>
                                <br />
                                <div className="col-md-6 form-group mb-1-5">
                                    <label>{t('block')}</label>
                                    <input type="text" className="form-control" placeholder={t('enter_block')} name="block" onChange={(e) => handleChange(e)} value={form?.block ? form?.block : ""} />
                                </div>
                                <div className="col-md-6 form-group mb-1-5">
                                    <label>{t('district')}</label>
                                    <input type="text" className="form-control" placeholder={t('enter_district')} name="district" onChange={(e) => handleChange(e)} value={form?.district ? form?.district : ""} />
                                </div>
                                <div className="col-md-12 form-group mb-1-5">
                                    <h5 className="signupInfo mb-0">{t('details_of_family_head')}</h5>
                                </div>
                                <div className="col-md-6 form-group mb-1-5">
                                    <label>{t('name_of_the_head')}</label>
                                    <input type="text" className="form-control" placeholder={t('enter_head_name')} name="head_name" onChange={(e) => handleChange(e)} value={form?.head_name ? form?.head_name : ""} />
                                </div>
                                <div className="col-md-6 form-group mb-1-5">
                                    <label>{t('birth_year')}</label>
                                    <input type="number" min="1949" max={current_date} step="1" className="form-control" placeholder={t('enter_dob')} name="birth_year" onChange={(e) => handleChange(e)} value={form?.birth_year ? form?.birth_year : ""} />
                                </div>
                                <div className="col-md-6 form-group mb-1-5">
                                    <label>{t('phone_number')}</label>
                                    <input type="text" className="form-control" placeholder={t('enter_phone_number')} value={form?.phone_number ? form?.phone_number : ""} />
                                </div>
                                <div className="col-md-6 form-group mb-1-5">
                                    <label>{t('father_name')}</label>
                                    <input type="text" className="form-control" placeholder={t('enter_father_name')} name="father_name" onChange={(e) => handleChange(e)} value={form?.father_name ? form?.father_name : ""} />
                                </div>
                                <div className="col-md-6 form-group mb-1-5">
                                    <label>{t('mother_name')}</label>
                                    <input type="text" className="form-control" placeholder={t('enter_mother_name')} name="mother_name" onChange={(e) => handleChange(e)} value={form?.mother_name ? form?.mother_name : ""} />
                                </div>
                                <div className="col-md-6 form-group mb-1-5">
                                    <label>{t('grandfather_name')}</label>
                                    <input type="text" className="form-control" placeholder={t('enter_gfather')} name="grand_father_name" onChange={(e) => handleChange(e)} value={form?.grand_father_name ? form?.grand_father_name : ""} />
                                </div>
                                <div className="col-md-6 form-group mb-1-5">
                                    <label>{t('grandmother_name')}</label>
                                    <input type="text" className="form-control" placeholder={t('enter_gmother')} name="grand_mother_name" onChange={(e) => handleChange(e)} value={form?.grand_mother_name ? form?.grand_mother_name : ""} />
                                </div>
                                <div className="col-md-6 form-group mb-1-5">
                                    <label>{t('cast')}</label>
                                    <input type="text" className="form-control" placeholder={t('enter_cast')} name="cast" onChange={(e) => handleChange(e)} value={form?.cast ? form?.cast : ""} autoComplete="off" />
                                </div>
                                <div className="col-md-6 form-group mb-1-5">
                                    <label>{t('education')}</label>
                                    <select className="form-control" value={form?.education ? form?.education : ""} name="education" onChange={(e) => handleChange(e)}>
                                        <option value="">{t('choose')}</option>
                                        <option value="Below Metric" >{t('belowMetric')}</option>
                                        <option value="Metric" >{t('Metric')}</option>
                                        <option value="Graduate">{t('graduate')} </option>
                                        <option value="Post Graduate">{t('postGraduate')}</option>
                                    </select>
                                </div>
                                <div className="col-md-6 form-group mb-1-5">
                                    <label>{t('marital_status')}</label>
                                    <select className="form-control rightArrow" value={form?.marital_status ? form?.marital_status : ""} name="marital_status" onChange={(e) => handleChange(e)}>
                                        <option value="">{t('choose')}</option>
                                        <option value="Married">{t('married')}</option>
                                        <option value="UnMarried">{t('unMarried')}</option>
                                    </select>
                                </div>

                                {

                                    form?.marital_status === "Married" &&
                                    <>
                                        <div className="col-md-6 form-group mb-1-5">
                                            <label>{t('spouse_name')}</label>
                                            <input type="text" placeholder={t('enter_spouse_name')} className="form-control" name="spouse_name" onChange={(e) => handleChange(e)} value={form?.spouse_name ? form?.spouse_name : ""} />
                                        </div>

                                        <div className="col-md-12 form-group mb-1-5">
                                            <h5 className="signupInfo">{t('detail_son_doughter')}</h5>
                                        </div>

                                        <MemberFamily items={items} addRows={addRows} removeRows={removeRows} updateState={updateState} />
                                    </>
                                }

                                <div className="col-md-6 form-group mb-1-5 business_details">
                                    <label>{t('occupation')}</label> <br />
                                    <div>
                                        <label>
                                            <input type="radio" value="Government" name="occupation" onChange={(e) => handleChange(e)} checked={form?.occupation === "Government"} />
                                            <span>{t('govt')}</span>
                                        </label>
                                        <label>
                                            <input type="radio" value="Private" name="occupation" onChange={(e) => handleChange(e)} checked={form?.occupation === "Private"} />
                                            <span>{t('pvt')}</span>
                                        </label>
                                        <label>
                                            <input type="radio" value="Business" name="occupation" onChange={(e) => handleChange(e)} checked={form?.occupation === "Business"} />
                                            <span>{t('business')}</span>
                                        </label>
                                    </div>
                                </div>
                                {
                                    form?.occupation === "Private" || form?.occupation === "Government" ?
                                        <>
                                            <div className="col-md-6 form-group mb-1-5">
                                                <label>{t('department')}</label>
                                                <input type="text" className="form-control" placeholder={t('enter_department')} name="department" onChange={(e) => handleChange(e)} value={form?.department ? form?.department : ""} />
                                            </div>
                                            <div className="col-md-6 form-group mb-1-5">
                                                <label>{t('position')}</label>
                                                <input type="text" className="form-control" placeholder={t('enter_position')} name="position" onChange={(e) => handleChange(e)} value={form?.position ? form?.position : ""} />
                                            </div>
                                        </>
                                        :
                                        ""
                                }
                                {
                                    form?.occupation === "Business" ?
                                        <div className="col-md-6 form-group mb-1-5">
                                            <label>{t('business_name')}</label>
                                            <input type="text" className="form-control" placeholder={t('enter_business')} name="business_name" onChange={(e) => handleChange(e)} value={form?.business_name ? form?.business_name : ""} />
                                        </div>
                                        :
                                        ""
                                }
                                {
                                    form?.occupation === "Private" || form?.occupation === "Business" ?
                                        <div className="col-md-6 form-group mb-1-5">
                                            <label>{t('company_name')}</label>
                                            <input type="text" className="form-control" placeholder={t('enter_company')} name="company_name" onChange={(e) => handleChange(e)} value={form?.company_name ? form?.company_name : ""} />
                                        </div>
                                        :
                                        ""
                                }
                                {
                                    form?.occupation === "Private" || form?.occupation === "Government" ?
                                        <>
                                            <div className="col-md-6 form-group mb-1-5">
                                                <label>{t('joining_date')}</label>
                                                <input type="date" className="form-control" name="joining_date" onChange={(e) => handleChange(e)} value={form?.joining_date ? form?.joining_date : ""} max={new Date().toISOString().split('T')[0]}/>
                                            </div>
                                            <div className="col-md-6 form-group mb-1-5">
                                                <label>{t('location')}</label>
                                                <input type="text" className="form-control" placeholder={t('enter_location')} name="location" onChange={(e) => handleChange(e)} value={form?.location ? form?.location : ""} />
                                            </div>
                                            <div className="col-md-6 form-group mb-1-5">
                                                <label>{t('post_tenure')}</label>
                                                <select className="form-control" value={form?.post_tenure ? form?.post_tenure : ""} name="post_tenure" onChange={(e) => handleChange(e)}>
                                                    <option value="">{t('choose')}</option>
                                                    <option value="Working">{t('working')}</option>
                                                    <option value="Retired">{t('retired')}</option>
                                                </select>
                                            </div>
                                            {
                                                form?.post_tenure && form?.post_tenure == "Retired" &&
                                                <div className="col-md-6 form-group mb-1-5">
                                                    <label>{t('relieving_date')}</label>
                                                    <input type="date" className="form-control" name="relieving_date" onChange={(e) => handleChange(e)} value={form?.relieving_date ? form?.relieving_date : ""} max={new Date().toISOString().split('T')[0]}/>
                                                </div>
                                            }
                                        </>
                                        : ""
                                }
                                <div className="col-md-6 form-group mb-1-5">
                                    <label>{t('other_post')}</label>
                                    <input type="text" className="form-control" placeholder={t('enter_position')} name="other_post" onChange={(e) => handleChange(e)} value={form?.other_post ? form?.other_post : ""} />
                                </div>
                                <div className="col-md-6 form-group mb-1-5">
                                    <label>{t('other_post_tenure')}</label>
                                    <select className="form-control" value={form?.other_post_duration ? form?.other_post_duration : ""} name="other_post_duration" onChange={(e) => handleChange(e)}>
                                        <option value="">{t('choose')}</option>
                                        <option value="Past">{t('past')}</option>
                                        <option value="Current">{t('current')}</option>
                                    </select>
                                </div>
                                {
                                    form?.marital_status === "Married" &&
                                    <>
                                        <div className="col-md-12 form-group mb-1-5">
                                            <h5 className="signupInfo">{t('details_of_maternal_house')}</h5>
                                        </div>
                                        <div className="col-md-6 form-group mb-1-5">
                                            <label>{t('village')}</label>
                                            <input type="text" className="form-control" placeholder={t('enter_village')} name="maternal_village" onChange={(e) => handleChange(e)} value={form?.maternal_village ? form?.maternal_village : ""} />
                                        </div>
                                        <div className="col-md-6 form-group mb-1-5">
                                            <label>{t('name')}</label>
                                            <input type="text" className="form-control" placeholder={t('enter_name')} name="maternal_name" onChange={(e) => handleChange(e)} value={form?.maternal_name ? form?.maternal_name : ""} />
                                        </div>
                                        <div className="col-md-6 form-group mb-1-5">
                                            <label>{t('relationship')}</label>
                                            <select className="form-control" value={form?.maternal_relationship ? form?.maternal_relationship : ""} name="maternal_relationship" onChange={(e) => handleChange(e)}>
                                                <option value="">{t('choose')}</option>
                                                <option value="Brother">{t('brother')}</option>
                                                <option value="Father">{t('father')}</option>
                                                <option value="Sister">{t('sister')}</option>
                                                <option value="Mother">{t('mother')}</option>
                                                <option value="Maternal uncle" >{t('maternalUncle')}</option>
                                            </select>
                                        </div>
                                        <div className="col-md-6 form-group mb-1-5">
                                            <label>{t('phone_number')}</label>
                                            <input type="number" className="form-control" placeholder={t('enter_phone_number')} name="maternal_phone" onChange={(e) => handleChange(e)} value={form?.maternal_phone ? form?.maternal_phone : ""} />
                                        </div>
                                    </>
                                }

                                <div className="form-group col-md-4 m-auto">
                                    {
                                        submitted ?
                                            <button className="btn btn-primary btn-block">{t('please_wait')}</button>
                                            :
                                            <button className="btn btn-primary btn-block">{t('save')}</button>
                                    }
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
        </div>
    );
}
export default Profile;